import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import PlayAudio from './PlayAudio';

class StockNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockNewsList: [],
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getAllStockNews(this.state.limit)
            .then(result => {
                console.log('StockNews', result);
                this.setState({ stockNewsList: result });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;
            return (
                <tr key={listValue.url + Math.random()}>
                    <td><a href={listValue.url} target="_blank" rel="noreferrer">
                        <img src={listValue.image} style={{ height: '100px', width: '100px' }} alt="" />
                    </a>
                    </td>
                    <td style={{ textAlign: 'left' }} >
                        <div><a href={listValue.url} target="_blank" rel="noreferrer">{listValue.title}</a></div>
                        <div style={{ fontSize: '10px' }}>{listValue.publishedDate}&nbsp;&nbsp;<Link style={{ fontSize: '10px', fontWeight: 'bold' }} to={url}>({listValue.symbol})</Link></div>
                        <div style={{ fontSize: '15px' }}>{listValue.text} <PlayAudio text={listValue.text}/></div>
                    </td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.stockNewsList !== undefined && this.state.stockNewsList.length !== undefined && this.state.stockNewsList.length > 0) {
            tableRow = this.state.stockNewsList.map(this.renderRow.bind(this));            
        } else {
            tableRow = <tr><td></td><td>No Data</td></tr>
        }
        console.log('stockNewsList', this.state.stockNewsList.length);

        return (
            <>
            <Link style={{ fontSize: "13px", fontWeight: 'bold' }} to={'/news'}>Latest News/Articles</Link> <Link style={{ fontSize: "10px" }} to={'/news'}>(See More)</Link>
            <Table striped bordered hover size="xs" responsive>
                <thead>
                </thead>
                <tbody>
                    {tableRow}
                </tbody>
            </Table>
            <Link style={{ fontSize: "10px", fontWeight: 'bold' }} to={'/news'}>See More News...</Link>
            </>            
        );
    }
}

export default StockNews;
